import cn from 'classnames';
import * as React from 'react';

import Toggle, { IProps as IToggleProps } from '../Toggle/Toggle';

import styles from './TextIconToggle.module.scss';

interface IProps extends IToggleProps {
  textClassName?: string;
  toggleClassName?: string;
  active?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement | HTMLButtonElement>) => void;
  dataAction?: string;
}

const TextIconToggle: React.FC<IProps> = ({
  title,
  disabled,
  textClassName,
  toggleClassName,
  trigger,
  type,
  onClick,
  active,
  dataAction,
  ...toggleProps
}: IProps) => {
  return (
    <React.Fragment>
      {!trigger ? (
        <button disabled={disabled} type={type} className={textClassName} onClick={onClick} data-action={dataAction}>
          {title}
        </button>
      ) : (
        <Toggle
          {...toggleProps}
          className={cn(styles.toggle, active ? styles.activate : styles.deactivate)}
          sliderClassName={styles.slider}
          switchClassName={styles.switch}
          checked={active}
          onClick={onClick}
          compact
        />
      )}
    </React.Fragment>
  );
};

export default TextIconToggle;
